(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Role', Role);

    Role.$inject = ['$resource'];

    function Role ($resource) {
        var resourceUrl =  'api/roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                    params: {
                        id: 'page'
                    },
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{
                method:'DELETE',
                params: {
                    login: 'id'
                }
            },
            'update': { method:'PUT' } ,
            'validate': {method:'GET',
                params:{
                    id:'exists'
                }
            }
        });
    }
})();
